(function () {
  const POINTS_PER_EURO = 85;

  function calcPoints(priceInCents) {
    if (!priceInCents || priceInCents <= 0) return 0;
    return Math.ceil((priceInCents / 100) * POINTS_PER_EURO);
  }

  function formatPoints(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
  }

  function openPopup(sectionId) {
    var popup = document.getElementById('forte-rp-popup-' + sectionId);
    if (!popup) return;
    popup.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
    var closeBtn = popup.querySelector('.forte-rp-popup__close');
    if (closeBtn) closeBtn.focus();
  }

  function closePopup(sectionId) {
    var popup = document.getElementById('forte-rp-popup-' + sectionId);
    if (!popup) return;
    popup.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
  }

  function hoistPopups() {
    document.querySelectorAll('.forte-rp-popup').forEach(function (popup) {
      if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
      }
    });
  }

  function init() {
    hoistPopups();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        var sectionId = event && event.data && event.data.sectionId;
        if (!variant || !sectionId) return;
        var countEl = document.getElementById('forte-rp-count-' + sectionId);
        if (!countEl) return;
        countEl.textContent = formatPoints(calcPoints(variant.price));
      });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-forte-popup]');
      if (trigger) {
        openPopup(trigger.getAttribute('data-forte-popup'));
        return;
      }
      var closer = e.target.closest('[data-forte-popup-close]');
      if (closer) {
        closePopup(closer.getAttribute('data-forte-popup-close'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.forte-rp-popup:not([hidden])').forEach(function (p) {
        var sid = p.id.replace('forte-rp-popup-', '');
        closePopup(sid);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
